export var updateBuyerIntentFilter = function updateBuyerIntentFilter(filter) {
  return {
    type: 'UPDATE_BUYER_INTENT_FILTER',
    data: filter
  };
};
export var updateBuyerIntentEvalState = function updateBuyerIntentEvalState(evalState) {
  return {
    type: 'UPDATE_BUYER_INTENT_EVAL_STATE',
    data: evalState
  };
};
export var updateCarCount = function updateCarCount(count) {
  return {
    type: 'UPDATE_CAR_COUNT',
    data: count
  };
};
export default {
  updateBuyerIntentEvalState: updateBuyerIntentEvalState
};